import React from "react";
import { Stack, Title, Card, Tabs, Space } from "@mantine/core";
import FearGreedImage from "./DataAPI/FearGreedImage";
import FearGreedData from "./DataAPI/FearGreedData";
import GlobalCapData from "./DataAPI/TotalCap";
import Top10CoinData from "./DataAPI/TopCoins";
import TrendingCoinData from "./DataAPI/TrendingNow";
import DeFi from "./DataAPI/DeFi";

import "./VizPage.css"; // Import the CSS file

export default function VizPage() {
  console.log(window.innerWidth);

  if (window.innerWidth > 1000) {
    return (
      <div>
        <Title order={2} className="viz-title">
          Global Cryptocurrency Status
        </Title>
        <div className="viz-page-container">
          <Tabs
            color="orange"
            variant="pills"
            radius="lg"
            orientation="vertical"
            defaultValue="top-10-cryptocurrencies"
          >
            <Tabs.List style={{ marginRight: 20 }}>
              <Tabs.Tab value="fear-greed-index">
                <Title fz="md">Fear Greed Index</Title>
              </Tabs.Tab>
              <Space h="xl" />
              <Tabs.Tab value="fear-greed-history">
                <Title fz="md">Fear Greed History</Title>
              </Tabs.Tab>
              <Space h="xl" />
              <Tabs.Tab value="global-cryptocurrency-market-cap">
                <Title fz="md">Global Cryptocurrency Market Cap</Title>
              </Tabs.Tab>
              <Space h="xl" />
              <Tabs.Tab value="top-10-cryptocurrencies">
                <Title fz="md">Top 10 Cryptocurrencies</Title>
              </Tabs.Tab>
              <Space h="xl" />
              <Tabs.Tab value="trending-coins">
                <Title fz="md">Trending Coins</Title>
              </Tabs.Tab>
              <Space h="xl" />
              <Tabs.Tab value="decentralized-finance">
                <Title fz="md">Decentralized Finance</Title>
              </Tabs.Tab>
              <Space h="xl" />
            </Tabs.List>

            <Tabs.Panel value="fear-greed-index">
              <div className="panel">
                  <FearGreedImage />
              </div>
            </Tabs.Panel>
            <Tabs.Panel value="fear-greed-history">
              <FearGreedData />
            </Tabs.Panel>
            <Tabs.Panel value="global-cryptocurrency-market-cap">
              <div className="panel_2">
                <GlobalCapData />
              </div>
            </Tabs.Panel>
            <Tabs.Panel value="top-10-cryptocurrencies">
              <Top10CoinData />
            </Tabs.Panel>
            <Tabs.Panel value="trending-coins">
              <Card withBorder>
                <Stack>
                  <Title order={4}>Trending Coins (powered by CoinGecko)</Title>
                  <div>
                    <TrendingCoinData />
                  </div>
                </Stack>
              </Card>
            </Tabs.Panel>
            <Tabs.Panel value="decentralized-finance">
                <DeFi />
            </Tabs.Panel>
          </Tabs>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <Stack p={24}>
          <Title order={2}>Global Cryptocurrency Status</Title>
          <Card>
            <Card withBorder>
              <Stack>
                <Title order={4}>Fear Greed Index</Title>
                <Card>
                  <FearGreedImage />
                </Card>
              </Stack>
            </Card>
            <Card withBorder>
              <Stack>
                <Title order={4}>Fear Greed History</Title>
                <Card>
                  <FearGreedData />
                </Card>
              </Stack>
            </Card>
          </Card>

          <Card>
            <Card withBorder>
              <Stack>
                <Title order={4}>Global Cryptocurrency Market Cap</Title>
                <div>
                  <GlobalCapData />
                </div>
              </Stack>
            </Card>
            <Card withBorder>
              <Stack>
                <Title order={4}>Top 10 Cryptocurrencies</Title>
                <div>
                  <Top10CoinData />
                </div>
              </Stack>
            </Card>
          </Card>

          <Card>
            <Card withBorder>
              <Stack>
                <Title order={4}>Trending Coins (powered by CoinGecko)</Title>
                <div>
                  <TrendingCoinData />
                </div>
              </Stack>
            </Card>
            <Card withBorder>
              <Stack>
                <Title order={4}>Decentralized Finance</Title>
                <div>
                  <DeFi />
                </div>
              </Stack>
            </Card>
          </Card>
          <Card></Card>
        </Stack>
      </div>
    );
  }

  // return (
  // 	<div>
  // 	<Stack p={24}>
  // 		<Title order={2}>Global Cryptocurrency Status</Title>
  // 		<Card>
  // 			<Grid columns={5}>
  // 				<Grid.Col span={2}>
  // 					<Card withBorder>
  // 						<Stack>
  // 							<Title order={4}>Fear Greed Index</Title>
  // 							<Card><FearGreedImage/></Card>
  // 						</Stack>
  // 					</Card>
  // 				</Grid.Col>
  // 				<Grid.Col span={3}>
  // 					<Card withBorder>
  // 						<Stack>
  // 							<Title order={4}>Fear Greed History</Title>
  // 							<Card><FearGreedData/></Card>
  // 						</Stack>
  // 					</Card>
  // 				</Grid.Col>
  // 			</Grid>
  // 		</Card>

  // 		<Card>
  // 			<Grid columns={10}>
  // 				<Grid.Col span={4}>
  // 					<Card withBorder>
  // 						<Stack>
  // 							<Title order={4}>Global Cryptocurrency Market Cap</Title>
  // 							<div><GlobalCapData /></div>
  // 						</Stack>
  // 					</Card>
  // 				</Grid.Col>
  // 				<Grid.Col span={6}>
  // 					<Card withBorder>
  // 						<Stack>
  // 							<Title order={4}>Top 10 Cryptocurrencies</Title>
  // 							<div><Top10CoinData/></div>
  // 						</Stack>
  // 					</Card>
  // 				</Grid.Col>
  // 			</Grid>
  // 		</Card>

  // 		<Card>
  // 			<Grid columns={10}>
  // 				<Grid.Col span={4}>
  // 					<Card withBorder>
  // 						<Stack>
  // 							<Title order={4}>Trending Coins (powered by CoinGecko)</Title>
  // 							<div><TrendingCoinData /></div>
  // 						</Stack>
  // 					</Card>
  // 				</Grid.Col>
  // 				<Grid.Col span={6}>
  // 					<Card withBorder>
  // 						<Stack>
  // 							<Title order={4}>Decentralized Finance</Title>
  // 							<div><DeFi /></div>
  // 						</Stack>
  // 					</Card>
  // 				</Grid.Col>
  // 			</Grid>
  // 		</Card>
  // 		<Card></Card>
  // 	</Stack>
  // 	</div>
  // )
}
